import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { enum_api_uri } from "../utils/enum";
import axiosInstance from "./axiosInstance";

export type DataListProps = {
    m_name: string;
    user_id: string;
};

export type ResponseData = DataListProps[];

export const useGetConsoleOrderCustomer = (): UseQueryResult<ResponseData, Error> => {
    let url = enum_api_uri.get_console_order_customer;
    return useQuery({
        queryKey: ["useGetConsoleOrderCustomer"],
        queryFn: async () => {
            const response = await axiosInstance.get(url);
            return response.data.data;
        },
    });
};
